export default "__VITE_ASSET__DZiEjZ8T__"